import React from 'react';

import DescriptionIcon from '@mui/icons-material/Description';
import {
	PoliciesItemImage,
	PoliciesItemLink,
	PoliciesItemWrap,
	PolicyTitle,
} from 'modules/Policies/components/PoliciesItem/styled';

import { IPoliciesItemModel } from '@common/models/Policies/PoliciesItem';

interface PoliciesItemProps {
	policiesItem: IPoliciesItemModel;
}

function PoliciesItem({ policiesItem }: PoliciesItemProps) {
	return (
		<PoliciesItemLink href={policiesItem.file_url} target="_blank" rel="noopener noreferrer">
			<PoliciesItemWrap>
				{!policiesItem?.image_url ? (
					<DescriptionIcon fontSize="large" />
				) : (
					<PoliciesItemImage src={policiesItem.image_url} alt="Policy image" />
				)}
				<PolicyTitle>{policiesItem.title}</PolicyTitle>
			</PoliciesItemWrap>
		</PoliciesItemLink>
	);
}

export default PoliciesItem;
